import React, { useMemo } from "react";
import { useCitiesUIContext } from "../CitiesUIContext";

export function CitiesGrouping() {
  // Cities UI Context
  const citiesUIContext = useCitiesUIContext();
  const citiesUIProps = useMemo(() => {
    return {
      ids: citiesUIContext.ids,
      setIds: citiesUIContext.setIds,
      openDeleteCitiesDialog: citiesUIContext.openDeleteCitiesDialog,
      openFetchCitiesDialog: citiesUIContext.openFetchCitiesDialog,
      openUpdateCitiesStatusDialog:
        citiesUIContext.openUpdateCitiesStatusDialog,
    };
  }, [citiesUIContext]);

  return (
    <div className="form mb-4">
      <div className="card card-custom bg-light border-0 py-3 px-6 d-flex flex-row align-items-center justify-content-between flex-wrap shadow-xs">
        <div className="d-flex align-items-center my-1 mr-4" style={{ gap: "10px" }}>
          <span className="font-weight-bolder font-size-sm" style={{ color: "#181C32", marginRight: "8px" }}>
            Selected Cities:
          </span>
          <span
            className="label label-primary label-inline font-weight-bolder font-size-sm py-2 px-3"
            style={{ backgroundColor: "#3699FF", color: "#ffffff", minWidth: "36px", textAlign: "center", borderRadius: "6px" }}
          >
            {citiesUIProps.ids.length}
          </span>
        </div>
        <div className="d-flex align-items-center my-1" style={{ gap: "8px" }}>
          <button
            type="button"
            className="btn btn-light-primary font-weight-bolder font-size-sm"
            onClick={citiesUIProps.openUpdateCitiesStatusDialog}
          >
            <i className="fa fa-sync-alt mr-1"></i> Update Status
          </button>
          <button
            type="button"
            className="btn btn-light-danger font-weight-bolder font-size-sm"
            onClick={citiesUIProps.openDeleteCitiesDialog}
          >
            <i className="fa fa-trash mr-1"></i> Delete Selected
          </button>
        </div>
      </div>
    </div>
  );
}
